import { CodeBlock } from '@atlaskit/code';
import { Stack } from '@atlaskit/primitives';
import { IconCardGroup } from '@af/design-system-docs-ui';
import { contactUsCardsInternalDev } from "../../../../src/pages/contact-us";
import { codeReactInstall, codeAtlaskitInstall, codeCSSResetImport, codeBabelInstall, codeBabelSetup, codeBabelPackageDistributionInstall, codeBabelPackageDistributionSetup, codeParcelInstall, codeParcelCompiledSetup, codeParcelRcSetup, codeWebpackInstall, codeWebpackSetup, codeViteInstall, codeViteSetup, codeESLintInstall, codeESLintSetup, codeButtonInstall, codeButtonUsage } from "../../../../src/snippets/code/develop";
import * as React from 'react';
export default {
  CodeBlock,
  Stack,
  IconCardGroup,
  contactUsCardsInternalDev,
  codeReactInstall,
  codeAtlaskitInstall,
  codeCSSResetImport,
  codeBabelInstall,
  codeBabelSetup,
  codeBabelPackageDistributionInstall,
  codeBabelPackageDistributionSetup,
  codeParcelInstall,
  codeParcelCompiledSetup,
  codeParcelRcSetup,
  codeWebpackInstall,
  codeWebpackSetup,
  codeViteInstall,
  codeViteSetup,
  codeESLintInstall,
  codeESLintSetup,
  codeButtonInstall,
  codeButtonUsage,
  React
};